import $ from 'jquery';
import keyBy from 'lodash/keyBy';

const countries = keyBy(WOW_DATA.countries, 'slug');

$('.js-extend-product-count-to-menu a[href]').each(function() {
  const match = $(this).attr('href').match(/([A-Za-z\-]+)\/?$/);
  if(match) {
    const slug = match[match.length-1];
    const country = countries[slug];
    if(country){
      $(this).append(' ('+ country.count_product +')');
    }
  }
});
